









































































































































































import Vue from 'vue'
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination,
  BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import TableSpinner from '@/views/components/table-spinner/TableSpinner.vue'
import pushStateFiltersParams from '@/helpers/pushStateFiltersParams'
import { appGroupWizardList } from '@/store/modules/app-group-wizard-list'
import { id } from '@/types'
import store from '@/store'

let debounceTimeout: ReturnType<typeof setTimeout> = setTimeout(() => '', 1000)

export default Vue.extend({
  name: 'GroupWizardList',
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BButton,
    BLink,

    vSelect,

    TableSpinner,
  },
  data() {
    return {
      currentRouteName: this.$router.currentRoute.name,
    }
  },
  computed: {
    tableColumns() {
      return appGroupWizardList.getters.getTableColumns
    },
    perPage() {
      return appGroupWizardList.getters.getPerPage
    },
    totalItems() {
      return appGroupWizardList.getters.getTotalItems
    },
    currentPage: {
      get() {
        return appGroupWizardList.getters.getCurrentPage
      },
      set(val: number) {
        appGroupWizardList.mutations.SET_CURRENT_PAGE(val)
      },
    },
    perPageOptions() {
      return appGroupWizardList.getters.getPerPageOptions
    },
    searchQuery: {
      get() {
        return appGroupWizardList.getters.getSearchQuery
      },
      set(val: string) {
        appGroupWizardList.mutations.SET_SEARCH_QUERY(val)
      },
    },
    sortBy() {
      return appGroupWizardList.getters.getSortBy
    },
    isSortDirDesc() {
      return appGroupWizardList.getters.getIsSortDirDesc
    },
    dataMeta() {
      return appGroupWizardList.getters.getDataMeta
    },
    programId() {
      return store.getters['verticalMenu/getDefaultProgram']
    },
  },
  watch: {
    $route() {
      if (!this.$route.query.currentPage) {
        this.setFilterParams()
      }
      this.updateTable()
    },
    programId() {
      this.updateTable()
    },
    currentPage(val, prevVal) {
      if (val !== prevVal) {
        pushStateFiltersParams(this, this.currentRouteName, 'currentPage', val)
      }
    },
    perPage(val, prevVal) {
      if (val !== prevVal) {
        pushStateFiltersParams(this, this.currentRouteName, 'perPage', val)
      }
    },
    searchQuery(val, prevVal) {
      if (val !== prevVal) {
        clearTimeout(debounceTimeout)
        debounceTimeout = setTimeout(() => {
          pushStateFiltersParams(this, this.currentRouteName, 'searchQuery', val)
        }, 250)
      }
    },
  },
  mounted() {
    this.setFilterParams()
    // Update filters
    window.onpopstate = () => {
      this.setFilterParams()
    }
  },
  methods: {
    updatePerPage(val: number) {
      appGroupWizardList.mutations.SET_PER_PAGE(val)
    },
    async fetchGroupWizardsList() {
      return appGroupWizardList.actions.fetchGroupWizardsList()
    },
    async deleteItem(id: id) {
      await appGroupWizardList.actions.deleteGroupWizard(id)
      this.updateTable()
    },
    updateTable() {
      (this.$refs.refGroupWizardsListTable as BTable).refresh()
    },
    setFilterParams() {
      appGroupWizardList.mutations.SET_FILTER_PARAMS()
    },
  },
})
